import routes from '@modules/team/team-routes';
import store from '@modules/team/team-store';

export default {
  routes,
  store,
};
